export const commonTableProps = {
  enableSelectionColor: false,
  hasHeaderFilters: false,
  allowEdit: false,
  disableUseEffect: true,
};
